export default __webpack_public_path__ + "static/media/circle-flags_ca.ad2b9273.svg";